<template>
  <a-spin :tip="loadingTip" :spinning="isloading">
    <div>
      <div class style="position: relative;margin-top: 30px;">
        <a-form :form="form" @submit="handleSubmit" style="width: 100%;">
          <a-form-item label="触发类型" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <a-select :change="typeChanged" v-model="info.type">
              <!-- <a-select-option :value="0">学分</a-select-option> -->
              <!-- <a-select-option :value="1">学时</a-select-option> -->
              <a-select-option :value="2">课程</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            label="课程学分"
            v-if="info.type==0"
            :label-col="{ span: 3 }"
            :wrapper-col="{ span: 21 }"
          >
            <a-input
              placeholder="请输入课程学分"
              v-decorator="[
                'value',
                {rules: [{ required: true, message: '请输入课程学分!' }],initialValue:info.value}
              ]"
            ></a-input>
          </a-form-item>
          <a-form-item
            label="课程学时"
            v-if="info.type==1"
            :label-col="{ span: 3 }"
            :wrapper-col="{ span: 21 }"
          >
            <a-input
              placeholder="请输入课程学时"
              v-decorator="[
                'value',
                {rules: [{ required: true, message: '请输入课程学时!' }],initialValue:info.value}
              ]"
            ></a-input>
          </a-form-item>

          <a-form-item
            label="关联课程"
            v-if="info.type==2"
            :label-col="{ span: 3 }"
            :wrapper-col="{ span: 21 }"
          >
            <a-button
              type="primary"
              :style="{ margin: '5px'}"
              class="ui-search-action"
              @click="chooseCourse()"
            >选择课程</a-button>
            <a-table
              :columns="courseInfo.columns"
              rowKey="id"
              :pagination="false"
              :dataSource="courseInfo.datas"
              :loading="isloading"
              size="small"
            >
              <span slot="status" slot-scope="status">
                <a-tag v-if="status==1" color="green">已发布</a-tag>
                <a-tag v-else-if="status==-1" color="red">未发布</a-tag>
                <a-tag v-else-if="status==2" color="red">直播中</a-tag>
                <a-tag v-else-if="status==3" color="green">已结束</a-tag>
                <a-tag v-else color="gray">已删除</a-tag>
              </span>
              <span slot="action" slot-scope="info">
                <pxkeji-btn name="移除" size="small" @click="removeCourse(info.id)" type="default" />
              </span>
            </a-table>
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 21, offset: 3 }">
            <pxkeji-btn name="保存" type="primary" htmlType="submit" />
          </a-form-item>
        </a-form>
      </div>
      <a-modal
        v-model="chooseCourseShow"
        :footer="false"
        destroyOnClose
        width="70%"
        :maskClosable="false"
        class="ui-modal"
      >
        <courseChoose @callbackMethod="addCourse" :ids="info.targetIds" />
      </a-modal>
    </div>
  </a-spin>
</template>

<script>
import courseChoose from "../train/courseChoose.vue";

const columns = [
  // {
  //   dataIndex: "id",
  //   key: "id",
  //   align: "center",
  //   title: "课程编码",
  // },
  {
    dataIndex: "name",
    key: "name",
    align: "center",
    title: "课程名称",
  },

  {
    dataIndex: "typeName",
    key: "typeName",
    align: "center",
    title: "课程分类",
  },
  {
    dataIndex: "presentPrice",
    key: "presentPrice",
    align: "center",
    title: "价格/元",
  },
  {
    dataIndex: "teacherName",
    key: "teacherName",
    align: "center",
    title: "讲师",
  },
  {
    dataIndex: "status",
    key: "status",
    align: "center",
    title: "状态",
    scopedSlots: { customRender: "status" },
  },
  {
    title: "操作",
    key: "action",
    align: "center",
    scopedSlots: { customRender: "action" },
  },
];
var that;
export default {
  name: "trigger",
  props: {
    id: String,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      courseInfo: {
        columns: columns,
        datas: [],
      },
      info: {
        type: 2,
        targetIds: [],
        courseIds: "",
      },
      chooseCourseShow: false, //选择课程
      isloading: false,
      loadingTip: "加载中...",
    };
  },
  components: {
    courseChoose,
  },
  mounted() {
    this.$nextTick(function () {
      that = this;
      this.getTrigger();
    });
  },
  methods: {
    chooseCourse() {
      this.chooseCourseShow = true;
    },
    removeCourse(id) {
      this.$confirm({
        title: "提示",
        content: "您确定要移除课程吗",
        okText: "确认",
        cancelText: "取消",
        onOk() {
          for (let i = 0; i < that.info.targetIds.length; i++) {
            if (id == that.info.targetIds[i]) {
              that.info.targetIds.splice(i, 1);
              break;
            }
          }
          that.info.courseIds = that.info.targetIds.join();
          that.getCourseListByIds();
        },
        onCancel() {},
      });
    },
    addCourse(ids) {
      this.chooseCourseShow = false;
      this.info.courseIds = ids;
      this.getCourseListByIds();
    },
    typeChanged(v) {
      if (v == 2) {
        this.info.targetIds = [];
      }
    },
    getTrigger() {
      this.isloading = true;
      this.$api.examination
        .getTrigger(this.id)
        .then((res) => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            if (res.data.trigger) {
              this.info = res.data.trigger;
              this.info.targetIds = this.info.targetIds
                ? this.info.targetIds
                : [];
              this.info.courseIds = this.info.targetIds.join();
              this.getCourseListByIds();
            }
          } else {
            this.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.isloading = true;

          this.$api.examination
            .setTrigger(
              this.id,
              this.info.type,
              values.value,
              this.info.targetIds ? this.info.targetIds.join(",") : ""
            )
            .then((res) => {
              this.isloading = false;
              if (res.errorCode == this.$msg.responseCode.success) {
                this.$message.success(res.errorMsg);
                this.$emit("callbackMethod", true);
              } else {
                this.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              this.isloading = false;
            });
        }
      });
    },
    getCourseListByIds() {
      this.isloading = true;
      this.$api.course
        .getCourseListByIds(this.info.courseIds)
        .then((res) => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.courseInfo.datas = res.data;
          } else {
            this.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    error(msg) {
      this.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        },
      });
    },
  },
};
</script>
<style>
</style>